import { getDisplayString, getReferenceString } from "@medplum/core";
import { Reference, Resource } from "@medplum/fhirtypes";
import { AsyncAutocompleteOption } from "@medplum/react";

export function resourceToOption<T extends Resource>(resource: T): AsyncAutocompleteOption<T> {
  return {
    value: getReferenceString(resource) ?? "",
    label: getDisplayString(resource),
    resource,
  };
}

export function referenceToOption<T extends Reference<Resource>>(
  reference: T,
): AsyncAutocompleteOption<T> {
  return {
    value: reference.reference ?? "",
    label: reference.display ?? "",
    resource: reference,
  };
}
